import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router'
import { confirmAlert } from 'react-confirm-alert' // Import
// import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import Modal from 'react-modal'

import { MainScreenMainHeader } from '../MainScreen/MainScreen'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'
import moment from 'moment'
import { notify } from 'react-notify-toast'
import { removeUserImages } from '../../Api/backendApi'

import backButtonIcon from '../../assets/entryScreen/backButtonIcon.png'
import editIcon from '../../assets/entryScreen/editButton.png'
import removeIcon from '../../assets/entryScreen/removeIcon.png'

export const ScreenHeader = styled(MainScreenMainHeader)`
  text-align: left;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(24)}
  font-weight: bold;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
  left: 25%;
  width: 50%;
  display: flex;
  justify-content: space-between;

  ${mediaQ(
    'mobileAll',
    `padding: 10px; align-items: center;box-sizing: border-box;`
  )}
`

export const BackbuttonIcon = styled.button`
  width: 30px;
  height: 15px;
  background: url(${backButtonIcon});
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
  margin-right: 20px;
`

const HeaderEntryActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 0 !important;
`

const HeaderEntryButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  cursor: pointer;
  justify-content: flex-end;

  span {
    font-family: 'Roboto';
    ${fontSizeResponsive(13)};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.15;
    letter-spacing: normal;
    text-align: left;
    color: #212121;
  }
`

const ActionButton = styled.button`
  width: 20px;
  height: 20px;
  background: ${(props) =>
    props.edit
      ? `url(${editIcon})`
      : props.remove
      ? `url(${removeIcon})`
      : null};
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
`

const extractDate = (entry) => {
  const splittedDate = entry.creation_datetime.split('-')

  const dateObj = {
    year: splittedDate[0],
    month: splittedDate[1],
    day: splittedDate[2],
  }

  return dateObj
}

const AgreeButton = styled.button`
  background-color: #bb2124;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: white;

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const CancelButton = styled.button`
  background-color: rgba(0, 0, 0, 0.05);
  opacity: 0.6;
  padding: 10px 40px;
  border: none;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.8);

  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  ${fontSizeResponsive(30)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`
const ModalButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
const ModalHeader = styled.h2`
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  ${fontSizeResponsive(45)};
  margin-bottom: 80px;
  padding: 0px 20px;
`

const EditImage = () => {}
const EntryHeader = ({
  entry,
  goBack,
  headerText,
  headerParent,
  enterRemoveImagesMode,
  isThisTodaysEntry,
  enableEditImages,
  isEditEntry,
  enterEditEntry,
  openRemoveEntryModal,
}) => {
  const date = entry && extractDate(entry)
  const history = useHistory()
  Modal.setAppElement('#root')

  const [modalIsOpen, setIsOpen] = React.useState(false)
  function openModal() {
    setIsOpen(true)
  }
  function closeModal() {
    setIsOpen(false)
  }

  const handleRemoveEntryClick = (entry) => {
    openRemoveEntryModal(entry)
  }

  const removeImages = () => {
    removeUserImages(entry.id)
    setTimeout(() => {
      history.go(0)
    }, 2000)
  }

  const onClickRemoveEntry = () => {
    openModal()
  }

  const onClickEditEntry = (entry) => {
    const date = new Date()
    const formattedDate = moment(date).format('YYYY-MM-DD')

    if (formattedDate == entry && entry.creation_datetime) {
      enterEditEntry()
    } else {
      notify.show(
        'Możesz edytować jedynie wpis dodany dzisiejszego dnia.',
        'error',
        5000
      )
    }
  }
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      zIndex: '1222',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  }
  return (
    <ScreenHeader>
      {headerParent === 'EntryScreen' && (
        <HeaderEntryActionContainer>
          {/* <HeaderEntryButtonContainer onClick={() => onClickEditEntry(entry)}>
            <ActionButton edit />
            <span>Edytuj wpis</span>
          </HeaderEntryButtonContainer> */}
          <HeaderEntryButtonContainer onClick={() => onClickRemoveEntry(entry)}>
            <ActionButton remove />
            <span>Usuń zdjęcia</span>
          </HeaderEntryButtonContainer>
          <Modal
            isOpen={modalIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <ModalHeader>
              Czy jesteś pewna, że chcesz usunąc zdjęcia z tego wpisu?
            </ModalHeader>
            <ModalButtonsContainer>
              <AgreeButton onClick={() => removeImages(entry)}>Tak</AgreeButton>
              <CancelButton onClick={closeModal}>Anuluj</CancelButton>
            </ModalButtonsContainer>
          </Modal>
          <HeaderEntryButtonContainer
            onClick={() => handleRemoveEntryClick(entry)}
          >
            <ActionButton remove />
            <span>Usuń wpis</span>
          </HeaderEntryButtonContainer>
        </HeaderEntryActionContainer>
      )}
    </ScreenHeader>
  )
}

EntryHeader.propTypes = {
  entry: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  headerParent: PropTypes.string,
  enterRemoveImagesMode: PropTypes.func.isRequired,
}

export default EntryHeader
